export enum ErrorCodes {
    INTERNAL_ERROR = 'INTERNAL_ERROR',
    NOT_FOUND = 'NOT_FOUND',
    UNAUTHORIZED = 'UNAUTHORIZED',
    FORBIDDEN = 'FORBIDDEN',
    VALIDATION_ERROR = 'VALIDATION_ERROR',
    BAD_REQUEST = 'BAD_REQUEST',
    CONFLICT = 'CONFLICT',
    RATE_LIMIT = 'RATE_LIMIT',
    SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
    DATABASE_ERROR = 'DATABASE_ERROR',
    NETWORK_ERROR = 'NETWORK_ERROR'
}

export class AppError extends Error {
    constructor(
        message: string,
        public statusCode: number = 500,
        public code: ErrorCodes = ErrorCodes.INTERNAL_ERROR
    ) {
        super(message);
        this.name = 'AppError';
        Object.setPrototypeOf(this, AppError.prototype);
    }

    static isAppError(error: unknown): error is AppError {
        return error instanceof AppError;
    }
}